import { render, staticRenderFns } from "./RegisterUsers.vue?vue&type=template&id=6c7a7131&scoped=true"
import script from "./RegisterUsers.vue?vue&type=script&lang=js"
export * from "./RegisterUsers.vue?vue&type=script&lang=js"
import style0 from "./RegisterUsers.vue?vue&type=style&index=0&id=6c7a7131&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a7131",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7a7131')) {
      api.createRecord('6c7a7131', component.options)
    } else {
      api.reload('6c7a7131', component.options)
    }
    module.hot.accept("./RegisterUsers.vue?vue&type=template&id=6c7a7131&scoped=true", function () {
      api.rerender('6c7a7131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/user/RegisterUsers.vue"
export default component.exports